import { IconBrandWhatsapp } from '@tabler/icons-react'
import { Container } from './styles'

type FloatButtonProps = {
  number?: string
}

export const FloatButton: React.FC<FloatButtonProps> = () => {
  return (
    <Container href='https://link.despertaenergia.com/atendimento-01' target='__blank'>
      <IconBrandWhatsapp size={32} color='white' />
    </Container>
  )
}
